import { getPaintings } from './getPaintings'
import { deletePainting } from './deletePainting'
import { sortPaintings } from './sortPaintings'
import { addPainting } from './addPainting'
import { editPainting } from './editPainting'

const api = {
  getPaintings,
  deletePainting,
  sortPaintings,
  addPainting,
  editPainting,
}
export default api
